var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-0", attrs: { id: "agents-select-container" } },
    [
      _c("div", [
        _vm.loading
          ? _c(
              "div",
              { class: _vm.formGroupClass },
              [
                _vm.loading
                  ? _c("b-skeleton", {
                      attrs: { type: "input", width: "95%", height: "1.5rem" },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _c(
              "div",
              [
                _vm.materialDesign
                  ? _c(
                      "h6",
                      {
                        staticClass: "form-title font-sm mb-0",
                        attrs: { for: "agents-select" },
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(_vm.computedLabel) + "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "material-input",
                  {
                    staticClass: "no-border",
                    attrs: {
                      id: "select-level",
                      "no-label": "",
                      label: _vm.$t("global.words.search"),
                      "hidden-label": true,
                    },
                  },
                  [
                    _c("v-select-field", {
                      staticClass: "search-input w-100 vsSelectedCheckboxes",
                      attrs: {
                        options: _vm.filteredAgents,
                        placeholder: _vm.$t("global.actions.chooseOption"),
                        clearable: false,
                        autoscroll: false,
                        "default-value": _vm.currentUser,
                        "has-active-filters": _vm.hasActiveFilters,
                        label: "fullName",
                        scenario: "agents",
                        "search-min-characters": 1,
                        disabled: _vm.disabled,
                        "has-checkboxes": _vm.hasCheckboxes,
                        "deselect-from-dropdown": "",
                        multiple: _vm.multiple || null,
                      },
                      on: {
                        "option:selected": _vm.handleChange,
                        "option:deselected": _vm.handleChange,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }